module.exports = __webpack_public_path__ + "img/newspic1.5fe62077.jpg";